export default "__VITE_ASSET__46a95d86__"